var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgWavePage404Top(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1440,
    height: 270,
    viewBox: "0 0 1440 270",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_204_83)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1440 216L1392 202.5C1344 189 1248 162 1152 162C1056 162 960 189 864 184.528C768 179.719 672 144.281 576 121.5C480 98.7187 384 90.2812 288 90.0281C192 90.2812 96 98.7187 48 103.528L0 108V0H48C96 0 192 0 288 0C384 0 480 0 576 0C672 0 768 0 864 0C960 0 1056 0 1152 0C1248 0 1344 0 1392 0H1440V216Z",
    fill: "#66BCE6"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_204_83"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1440,
    height: 270,
    fill: "white",
    transform: "translate(1440 270) rotate(-180)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWavePage404Top);
export default __webpack_public_path__ + "static/media/wavePage404Top.779b8186571a59d65ea8d0ffb1a4912c.svg";
export { ForwardRef as ReactComponent };